export const GTM_CONTAINER_ID = "GTM-ZJ7X7V8"

export const shouldLoadGtm = (consent: {
  analytics: boolean
  marketing: boolean
}) => consent.analytics || consent.marketing

export const isGtmLoaded = (): boolean =>
  typeof window !== "undefined" &&
  // @ts-ignore
  !!window.google_tag_manager?.[GTM_CONTAINER_ID]

/** Standard GTM bootstrap; consent defaults must already be in dataLayer. */
export const loadGoogleTagManager = (): void => {
  if (typeof window === "undefined" || isGtmLoaded()) return
  // @ts-ignore — GTM global
  const dataLayer = window.dataLayer || (window.dataLayer = [])
  dataLayer.push({
    platform: "gatsby",
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  })
  const script = document.createElement("script")
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_CONTAINER_ID}`
  document.head.appendChild(script)
}
